import { css as reactCss } from '@emotion/react';

import { CartItem } from 'api/api';

import { colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';

type SplitDeliveryCartItemProps = {
  cartItem: CartItem;
  isFolded: boolean;
};

export const SplitDeliveryCartItem: React.FC<SplitDeliveryCartItemProps> = ({
  cartItem,
  isFolded,
}) => {
  const image = cartItem.image_url ? (
    <img
      alt={cartItem.name}
      css={styles.image}
      style={{ objectFit: 'contain' }}
      src={cartItem.image_url}
    />
  ) : null;

  const renderItemDescription = !isFolded && (
    <div css={styles.textWrapper}>
      <span>{cartItem.name}</span>
      <div css={styles.quantity}>
        {cartItem.quantity !== undefined && <span>× {cartItem.quantity}</span>}
      </div>
    </div>
  );

  return (
    <div css={styles.wrapper}>
      {image && (
        <div data-branding="split-delivery-item-image-wrapper" css={styles.imageWrapper}>
          {image}
        </div>
      )}
      {renderItemDescription}
    </div>
  );
};

const styles = {
  wrapper: reactCss({
    display: 'flex',
    flexDirection: 'row',
    flex: 1,

    '&:not(:last-of-type)': {
      marginRight: '12px',
    },
  }),
  imageWrapper: {
    height: '80px',
    width: '50px',
    minWidth: '50px',
  },
  textWrapper: reactCss({
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '16px',
    ...fontStyles.px14_20,
  }),
  quantity: {
    color: colors.darkGrey,
  },
  image: {
    height: '100%',
    width: '100%',
  },
};
